@keyframes openADModal
    0%
        opacity: 0
    100%
        opacity: 0.6
.ADModal
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    background: rgb($globalSettingsFontPrimary)
    cursor: pointer
    z-index: $indexOverlay
    animation: 0.2s ease-in-out 0s 1 openADModal
    animation-fill-mode: forwards
    opacity: 0

.ADWrapper
    color: rgb($globalSettingsFontPrimary)
    position: fixed
    width: calc(100% - 20px)
    max-width: 740px
    min-height: 0
    max-height: calc(100% - 20px)
    left: calc(50% - 10px)
    top: calc(50% - 10px)
    transform: translate(-50%, -50%)
    background-color: rgb($globalSettingsBackgroundPrimary)
    margin: 10px
    box-sizing: border-box
    z-index: $indexDetails
    border-radius: $globalSettingsRoundingLarge
    display: flex
    flex-direction: column
    overflow: hidden
    .ADInfoTrigger
        width: 100%
        display: flex
        flex-direction: column
    .ADBackButton
        padding: 0 20px
        display: flex
        flex-direction: row
        align-items: center
        gap: 10px
        stroke: rgb($globalSettingsFontPrimary)
        cursor: pointer
        &:hover
            color: rgb($globalSettingsFontSecondary)
            stroke: rgb($globalSettingsFontSecondary)

\rtr-article-details-template-no-gallery
    min-height: 0
    display: flex
    flex-direction: column
    overflow: hidden
    .ADContainer
        position: relative
        min-height: 0
        width: 100%
        overflow-x: hidden
        overflow-y: auto
        .ADLocation
            width: 100%
            padding: 0 20px

.ADCFullGallery
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    display: flex
    flex-direction: column
    overflow: hidden
    background-color: rgb($globalSettingsBackgroundPrimary)
    z-index: 10
    animation: showGallery 0.2s linear
    .ADCFullGalleryHeader
        width: 100%
        height: 60px
        display: flex
        flex-direction: row
        align-items: center
        flex-shrink: 0
        border-bottom: 1px solid rgb($globalSettingsStrokeTertiary)
    .ADCFullGalleryInner
        width: 100%
        min-height: 0
        overflow-x: hidden
        overflow-y: auto

@keyframes showGallery
    0%
        opacity: 0
    100%
        opacity: 1
